/*
 * @Date: 2022-08-10 18:17:26
 * @LastEditTime: 2022-08-16 10:08:35
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_SigninForPasswordChange = (...params) =>
  net_common.post("/api/STDSCM01C02/SigninForPasswordChange", ...params);

export const API_Login = (...params) =>
  net_common.post("/api/STDSCM01C02/Login", ...params);

export const API_BopPortal = (...params) =>
  net_common.post("/api/STDSCM01C02/BopPortal", ...params);